import React, { useState, useEffect } from "react"
import { Row, Col, Card, Form, CardBody, Label } from "reactstrap"
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
import { fileUpload } from "store/actions"
import { connect } from "react-redux"
import PDFIcon from "assets/images/icons8-pdf-80.png"
const FileUpload = props => {
  const [selectedFiles, setselectedFiles] = useState({})
  useEffect(() => {
    if (selectedFiles.length !== 0) {
      props.onChange(selectedFiles)
    }
  }, [selectedFiles])

  function handleAcceptedFiles(files) {
    console.log(files)
    Object.assign(files, {
      preview: URL.createObjectURL(files[0]),
      formattedSize: formatBytes(files[0].size),
    })

    setselectedFiles(files[0])
  }

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  return (
    <div>
      <Row>
        <Col className="col-12">
          <Card>
            <Col>
              {/* {selectedFiles.length !== 0 ? (
                <button
                  onClick={() => {
                    setselectedFiles([])
                  }}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              ) : null} */}
            </Col>
            <CardBody>
              <div>
                <Label>
                  <small>Maximum file size: 5mb</small>
                </Label>
                {/* <Dropzone
                  accept="image/png, image/jpeg, image/jpg, image/txt, application/pdf"
                  maxFiles={1}
                  maxSize={1e7}
                  onDrop={acceptedFiles => {
                    handleAcceptedFiles(acceptedFiles)
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone> */}
                <input
                  //value={merchantDetails.Logo}
                  className="form-control"
                  type="file"
                  id="formFile"
                  name="Logo"
                  onChange={acceptedFiles =>
                    handleAcceptedFiles(acceptedFiles.target.files)
                  }
                  // ref={register({ required: true })}
                />

                {/* <div className="dropzone-previews mt-3" id="file-previews">
                  {selectedFiles.map((f, i) => {
                    return (
                      <Card
                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                        key={i + "-file"}
                      >
                        <div className="p-2">
                          <Row className="align-items-center">
                            <Col className="col-auto">
                              {f.type === "application/pdf" ? (
                                <img
                                  data-dz-thumbnail=""
                                  height="80"
                                  className="avatar-sm rounded bg-light"
                                  alt={f.name}
                                  src={PDFIcon}
                                />
                              ) : (
                                <img
                                  data-dz-thumbnail=""
                                  height="80"
                                  className="avatar-sm rounded bg-light"
                                  alt={f.name}
                                  src={f.preview}
                                />
                              )}
                            </Col>
                            <Col>
                              <Link
                                to="#"
                                className="text-muted font-weight-bold"
                              >
                                {f.name}
                              </Link>
                              <p className="mb-0">
                                <strong>{f.formattedSize}</strong>
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </Card>
                    )
                  })}
                </div> */}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
const mapStateToProps = state => {
  return {}
}
export default connect(mapStateToProps)(FileUpload)
